import React from 'react'
import { x } from '@xstyled/styled-components'
import { Navbar } from '@pool/components/navbar/Navbar'
import { Footer } from '@pool/components/footer/Footer'
import { BlogHero } from '@pool/components/blog/BlogHero'
import { BlogCard } from '@pool/components/blog/BlogCard'
import { BlogListSeo } from '@pool/components/blog/BlogSeo'
import { posts } from '@pool/content/blog/posts'

export function BlogListPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <x.main>
      <BlogListSeo />
      <Navbar />
      <BlogHero />
      <x.section
        w={{ _: '100%', maxWidth: 'maxWidth' }}
        mx="auto"
        px={{ _: '30px', md: '60px' }}
        pb={{ _: 12, md: 20 }}>
        <x.div
          display="grid"
          gridTemplateColumns={{
            _: '1fr',
            md: 'repeat(2, 1fr)',
            xl: 'repeat(3, 1fr)'
          }}
          gap={{ _: 5, md: 6 }}>
          {posts.map(({ frontmatter }) => (
            <BlogCard key={frontmatter.slug} frontmatter={frontmatter} />
          ))}
        </x.div>
      </x.section>
      <Footer />
    </x.main>
  )
}
